import { Routes, Route } from 'react-router-dom';
import './App.css';

import Home from './Components/Home/Home';
import Header from './Components/Header/Header';
import BrandStrip from './Components/BrandStrip/BrandStrip';
import HomePage from './Components/HomePage/HomePage';
import ServicesPage from './Components/ServicesPage/ServicesPage';
import Footer from './Components/Footer/Footer';
import ContactUsPage from './Components/ContactUs/ContactUsPage';
import CareerPage from './Components/CareerPage/CareerPage';
import JobDetailsPage from './Components/CareerPage/JobDetailsPage';
import GetInTouchSection from './Components/GetInTouch/GetInTouch';
import AboutSection from './Components/AboutSection/AboutSection';
import { LegalPage } from './Components/LegalPage/LegalPage';

function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/brandstrip" element={<BrandStrip />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/contact-us" element={<ContactUsPage />} /> 
        <Route path="/careers" element={<CareerPage />} />
        <Route path="/careers/:jobId" element={<JobDetailsPage />} />
        <Route path="/services/:service" element={<ServicesPage />} />
        <Route path="/legal/:type" element={<LegalPage />} />
        <Route path="/contact" element={<GetInTouchSection />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
